import template from './addNew.html';
import controller from './addNew.controller';
import './addNew.scss';

let addNewComponent = {
  bindings: {
    close: '&',
    dismiss: '&',
    resolve: '<'
  },
  template,
  controller,
  controllerAs: "vm"
};

export default addNewComponent;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/information/addNew/addNew.component.js